function calculateDiscountCP(modifiedPrice, { price, type, value }) {
    try {
        const { ODiscountType } = BSS_B2B.enum;
        const rateMarket = Number(window.Shopify.currency.rate) || 1;

        let newModifiedPrice = modifiedPrice;
        let discountValue = 0;

        const priceWithStoreCurrency = price / rateMarket;

        switch (type) {
            case ODiscountType.APPLY_FIXED:
                value = value * 100;
                if (value < priceWithStoreCurrency) {
                    discountValue = (priceWithStoreCurrency - value) / 100;
                    discountValue = discountValue * rateMarket * 100;
                    newModifiedPrice = price - discountValue;
                }
                break;

            case ODiscountType.DECREASE_FIXED:
                discountValue = value * rateMarket * 100;
                newModifiedPrice = price > discountValue ? price - discountValue : 0;
                break;

            case ODiscountType.DECREASE_PERCENTAGE:
                discountValue = (priceWithStoreCurrency * value) / 100;
                discountValue = discountValue * rateMarket;
                newModifiedPrice = price - discountValue;
                break;
        }

        return newModifiedPrice;
    } catch (error) {
        console.error('calculateDiscountCP error:', error);
    }
    return modifiedPrice;
}

window.BSS_B2B.addFilter('custom:cpPrice/round', calculateDiscountCP); 